<form [formGroup]="calculateMidnightShiftForm" id="caluclationForm">
    <div class="modal-body device-selection" id="shiftCalculation">
        <div class="row" id="rowShift">
            <div class="col-6">
                <p id="MidnightShift-calculate-text" class="device-modal-title">Calculate Midnight Shift</p>
                <p id="MidnightShift-coordinates-text" class="device-modal-sub-title">Coordinates</p>
            </div>
        </div>
    </div>
    <div class="heading" id="headingShift">
        <p>Degrees</p>
        <p>Minutes</p>
        <p>Seconds</p>
    </div>
    <p id="MidnightShift-latitude-text" class="device-modal-sub-title pdl-48">Latitude</p>
    <div class="flex" formGroupName="latitude" id="latitudeShift">
        <div class="flex-row-custom">
            <input type="tel" id="degree"
                [ngClass]="{ 'is-invalid': calculateMidnightShiftForm.controls['latitude'].controls['degrees'].errors && calculateMidnightShiftForm.controls['latitude'].controls['degrees'].dirty }"
                formControlName="degrees" (keypress)="numberOnly($event)" class="form-control textbox" />
            <input type="tel" id="minute"
                [ngClass]="{ 'is-invalid': calculateMidnightShiftForm.controls['latitude'].controls['minutes'].errors && calculateMidnightShiftForm.controls['latitude'].controls['minutes'].dirty }"
                formControlName="minutes" (keypress)="numberOnly($event)" class="form-control textbox" />
            <input type="tel" id="second"
                [ngClass]="{ 'is-invalid': calculateMidnightShiftForm.controls['latitude'].controls['seconds'].errors && calculateMidnightShiftForm.controls['latitude'].controls['seconds'].dirty }"
                formControlName="seconds" (keypress)="numberOnly($event)" class="form-control textbox" />
        </div>
        <div class="grid-row">
            <label aria-hidden="true">
                <input type="radio"
                    [ngClass]="{ 'is-invalid': calculateMidnightShiftForm.controls['latitude'].controls['hemisphere'].errors && calculateMidnightShiftForm.controls['latitude'].controls['hemisphere'].touched }"
                    id="north-option" formControlName="hemisphere" value="North" />
                <span class="pdl-5">North</span>
            </label>
            <label aria-hidden="true">
                <input type="radio"
                    [ngClass]="{ 'is-invalid': calculateMidnightShiftForm.controls['latitude'].controls['hemisphere'].errors && calculateMidnightShiftForm.controls['latitude'].controls['hemisphere'].touched }"
                    id="south-option" formControlName="hemisphere" value="South" />
                <span class="pdl-5">South</span>
            </label>
        </div>
    </div>
    <p id="MidnightShift-longitude-text"  class="device-modal-sub-title pdl-48">Longitude</p>
    <div class="flex" formGroupName="longitude" id="longitude">
        <div class="flex-row-custom">
            <input type="tel" id="longDegree"
                [ngClass]="{ 'is-invalid': calculateMidnightShiftForm.controls['longitude'].controls['degrees'].errors && calculateMidnightShiftForm.controls['longitude'].controls['degrees'].dirty }"
                formControlName="degrees" (keypress)="numberOnly($event)" class="form-control textbox" />
            <input type="tel" id="longMin"
                [ngClass]="{ 'is-invalid': calculateMidnightShiftForm.controls['longitude'].controls['minutes'].errors && calculateMidnightShiftForm.controls['longitude'].controls['minutes'].dirty }"
                formControlName="minutes" (keypress)="numberOnly($event)" class="form-control textbox" />
            <input type="tel" id="longSec"
                [ngClass]="{ 'is-invalid': calculateMidnightShiftForm.controls['longitude'].controls['seconds'].errors && calculateMidnightShiftForm.controls['longitude'].controls['seconds'].dirty }"
                formControlName="seconds" (keypress)="numberOnly($event)" class="form-control textbox" />
        </div>
        <div class="grid-row">
            <label aria-hidden="true">
                <input type="radio"
                    [ngClass]="{ 'is-invalid': calculateMidnightShiftForm.controls['longitude'].controls['hemisphere'].errors && calculateMidnightShiftForm.controls['longitude'].controls['hemisphere'].touched }"
                    id="east-option" formControlName="hemisphere" value="East" />
                <span class="pdl-5">East</span>
            </label>
            <label aria-hidden="true">
                <input type="radio"
                    [ngClass]="{ 'is-invalid': calculateMidnightShiftForm.controls['longitude'].controls['hemisphere'].errors && calculateMidnightShiftForm.controls['longitude'].controls['hemisphere'].touched }"
                    id="west-option" formControlName="hemisphere" value="West" />
                <span class="pdl-5">West</span>
            </label>
        </div>
    </div>
    <div class="modal-body device-selection" id="selection">
        <div class="row">
            <div class="col-6" style="margin-top: 1.5em;">
                <span class="device-modal-sub-title timezone-label">Timezone</span> 
                <input type="tel" formControlName="timeZone" (keypress)="numberOnly($event)" id="timeZone"
                    class="form-control textboxCustom"
                    [ngClass]="{ 'is-invalid': calculateMidnightShiftForm.controls['timeZone'].errors && calculateMidnightShiftForm.controls['timeZone'].dirty }" />
                <span id="MidnightShift-daylightSaving-text" class="device-modal-sub-title">Daylight Saving</span><input class="subCheckBox" type="checkbox"
                    formControlName="daylightSaving" class="primary-checkbox" id="daylightSaving" />
                <label for="daylightSaving" class="enable-graph-label" aria-label="Daylight Saving"><span id="daylightSaving-checkbox"></span></label>
                <p id="Calculated-MidnightShift-PopUpValue" class="device-modal-sub-title-pd">Calculated Midnight
                    Shift&nbsp;&nbsp;&nbsp;{{midNightShiftVal}}</p>
            </div>
        </div>
    </div>
    <div class="modal-body device-selection" id="calcOperation">
            <tr>
                <td>
                    <button id="MidnightShift-cancel-btn" type="button" class="btn CalShift-cancel-btn" (click)="onCancel()">Cancel</button>
                </td>
                <td><button id="MidnightShift-set-btn" type="button" class="btn CalShift-select-btn" (click)="setMidNightShiftVal($event)" [disabled]="isSetButtonDisabled">Set</button></td>
            </tr>
    </div>
</form>
